module.exports = __webpack_public_path__ + "img/video.90c8df8a.png";